import { Spinner } from "@material-tailwind/react";

export function PageFootLoading() {
  return (
    <div className="flex flex-col inset-0 flex items-center">
      <Spinner
        className="h-50 w-50 text-gray-900/50 mr-[10px]"
        color="purple"
      />
      <div className="text-white text-[18px] mt-[10px]">Loading More</div>
    </div>
  );
}
